export const styles = theme => ({
  errorMessage: {
    color: theme.palette.primary.darkRed,
    textTransform: 'uppercase',
  },
});
